import { makeGraphQLRequest } from '../utils/requestUtils';

export async function organizationInDB(cageCode) {
  // Format Query
  const query = `query organizationInDB(
    $cageCode: String
  ) {
    organizationInDB(cageCode: $cageCode) {
      id
      name
      address1
      address2
      address3
      zipCode
      cntry
      pointOfContact
      phoneNumber
      organizationType
      city
      state
      iconStatus
      users {name phoneNumber email role id organizationId auth0Id iconStatus cageCode} 
      admins{name email }
      
      }
    }`;

  const variables = { cageCode };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function organizationForRegistration(cageCode) {
  // Format Query
  const query = `query organizationInDB(
        $cageCode: String
      ) {
        organizationInDB(cageCode: $cageCode) {
          id
          name
          address1
          address2
          address3
          zipCode
          cntry
          pointOfContact
          phoneNumber
          organizationType
          city
          state
          iconStatus 
          
          }
        }`;

  // Variables
  const variables = { cageCode };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getSamDataByCageAPI(cageCode) {
  // Format Query
  const query = `query organizationSamDataByCage(
    $cageCode: String
  ) {
    organizationSamDataByCage(cageCode: $cageCode) {
      org {

        cageCode
        name
        phoneNumber
        faxNumber
        address1
        address2
        iconStatus
        city
        state
        email
        pointOfContact
        zipCode   
        cntry
        websiteUrl
        governmentBusiness {
          city
          cntry
          poc
          pocEmail
          pocState
          pocTitle
          streetAddress1
          streetAddress2
          zip
        }
        altGvernmentBusiness {
          city
          cntry
          poc
          pocEmail
          pocState
          pocTitle
          streetAddress1
          streetAddress2
          zip
        }
        electronicBusiness {
          city
          cntry
          poc
          pocEmail
          pocState
          pocTitle
          streetAddress1
          streetAddress2
          zip
        }
        altElectronicBusiness {
          city
          cntry
          poc
          pocEmail
          pocState
          pocTitle
          streetAddress1
          streetAddress2
          zip
        }
        pastPerformance {
          city
          cntry
          poc
          pocEmail
          pocState
          pocTitle
          streetAddress1
          streetAddress2
          zip
        }
        altPastPerformance {
          city
          cntry
          poc
          pocEmail
          pocState
          pocTitle
          streetAddress1
          streetAddress2
          zip
        }
        naics
        industryType
        industryAssociations
      }  
      selectedPoc
      phone
      emailAddress
      name
      industryAssociationsList
      naicsFoundryCodesList
      naicsMachineCodesList
      naicsForgingCodesList
      naicsOthersCodesList
      industryTypesList
      }
    }`;

  // Variables
  const variables = { cageCode };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getSamDataWithoutCageAPI(cageCode) {
  // Format Query
  const query = `query listsSamDataWithoutCage(
    $cageCode: String
  ) {
    listsSamDataWithoutCage(cageCode: $cageCode) {
      industryAssociationsList
      naicsFoundryCodesList
      naicsMachineCodesList
      naicsForgingCodesList
      naicsOthersCodesList
      industryTypesList
      }
    }`;

  // Variables
  const variables = { cageCode };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getOrgByID(id) {
  // Format Query
  const query = `query organization(
    $id: ID
  ) {
    organization(id: $id) {
      id
      name
      iconStatus
      address1
      address2
      address3
      cageCode
      zipCode
      cntry      
      pointOfContact
      email
      phoneNumber
      organizationType
      city
      state
      websiteUrl
      industryType
      industryAssociations
      associationValidations { name status expiration uniqueId pocUniqueId updated }
      naics
      isCageInSam
      admins {name email phoneNumber cageCode role id iconStatus permissions billsbyCustomerId}
      users {name email phoneNumber cageCode role id iconStatus  permissions}
      }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export async function getOrgAdmins(id) {
  // Format Query
  const query = `query organization(
    $id: ID
  ) {
    organization(id: $id)  { id organizationType admins {name phoneNumber email role id organizationId auth0Id }  users {name phoneNumber email role id organizationId auth0Id }  }
    }`;

  // Variables
  const variables = { id };

  const response = await makeGraphQLRequest({
    query,
    variables,
  });
  return response;
}

export default {
  getOrgByID,
  organizationInDB,
  organizationForRegistration,
  getSamDataByCageAPI,
  getOrgAdmins,
};



// WEBPACK FOOTER //
// ./src/graphql/organizationDetails.js